<template>
  <div class="wrapper">
    <div>
    <CButton   color="info" @click="openNew"><b>Add New Article</b></CButton>
    
     <CRow class="mt-3">
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="true"
                            :btn_destroy="true"
                            @showArticle="handleShowArticle"
                            @editArticle="handleEditArticle"
                            @publishArticle="handlechangeToPublish"
                            @unpublishArticle="handlechangeToUnpublish"
                            @deactivateArticle="handleDeactivate"
                            @reactivateArticle="handleReactivate"
                            @destroyArticle="handleDestroy"
                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <!-- <pre>{{ $data | json }}</pre> -->
    <alertmodal></alertmodal>
  </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_article.vue'
import axios from 'axios'
import article from '@/services/article'
import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'
import moment from 'moment';
const token = localStorage.getItem('token');

export default {
  name: 'article',
  components: { alertmodal, Datatable},
  data(){
    return{
     
      updateSubmit: false,
      largeModal:false,
    

      fields: [
          {key: 'title', sortable: false, },
          {key: 'author', sortable: false, },
          {key: 'article_category', sortable: false, },
          {key: 'publish_date', sortable: false, },
          {key: 'is_active', sortable: false, },
          {key: 'is_publish', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'title',
      sortByDesc: false,
      is_active: 1,
      //end
    }
    //end
  },

  created() {
      //this.loadData()
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE_ARTICLE', (data) => {
      if(data){
          this.loadData(); 
      }
    });
   },

   beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('TABLE_UPDATE_ARTICLE')
  },
   
  methods: {
    openNew: function (){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit article') !== -1){
          //IF ALLOW
          this.$router.push({name:'Article Form'})
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
     openShow(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('View article') !== -1){
          //IF ALLOW
          this.$router.push({name:'Article Detail',query: {id:id} })
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
    openEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit article') !== -1){
          //IF ALLOW
          this.$router.push({name:'Article Form',query: {id:id} })
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },  
    publishArticle(id){  
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit article') !== -1){
          //IF ALLOW
          if(confirm("Do you really want to publish this article?")){
            article.publishArticle(id)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          } 
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END  
    },
     unpublishArticle(id){   
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit article') !== -1){
          //IF ALLOW
          if(confirm("Do you really want to unpublish this article?")){
            article.unpublishArticle(id)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }  
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
    deactivateArticle(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit article') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        article.deactivateArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    reactivateArticle(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit article') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        article.reactivateArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    destroyArticle(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete article') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete?")){
        article.destroyArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      article.getArticleDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
          const formattedData = getData.data.map(item => {
            return{
              ...item,
              publish_date: moment(item.publish_date).format("DD/MM/YYYY")
            }
            })
          this.items = formattedData
          
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        console.log ('tes')
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShowArticle(val) {
        this.openShow(val) 
    }, 
    handleEditArticle(val) {
        this.openEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivateArticle(val)       
    },
    handlechangeToPublish(val) {
        this.publishArticle(val) 
    },  
    handlechangeToUnpublish(val) {
        this.unpublishArticle(val)       
    },
    handleReactivate(val) {
        this.reactivateArticle(val)       
    },
    handleDestroy(val) {
        this.destroyArticle(val)       
    },
  }
}
</script>
